var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Talent } from 'packages/talent/entities/Talent';
import StatefulThreadBrowser from 'ui/v1/email/StatefulThreadBrowser.vue';
import EmptyState from 'ui/v1/EmptyState.vue';
import { namespace } from 'vuex-class';
var talentCardModule = namespace('talentCard');
var talentEmail = namespace('talentCard/talentEmailState');
var TalentEmailView = /** @class */ (function (_super) {
    __extends(TalentEmailView, _super);
    function TalentEmailView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showEmptyState = false;
        _this.composingEmail = false;
        _this.hasUnsavedChanges = false;
        return _this;
    }
    TalentEmailView.prototype.created = function () {
        window.addEventListener('beforeunload', this.preventNavigation);
    };
    TalentEmailView.prototype.onEmailSent = function () {
        this.hasUnsavedChanges = false;
        this.$emit('email-sent');
    };
    TalentEmailView.prototype.checkThreads = function () {
        var _a;
        if (((_a = this.threads) === null || _a === void 0 ? void 0 : _a.length) === 0 && !this.composingEmail) {
            return this.showEmptyState = true;
        }
        return this.showEmptyState = false;
    };
    TalentEmailView.prototype.openEmailForm = function () {
        this.composingEmail = true;
        this.showEmptyState = false;
    };
    TalentEmailView.prototype.preventNavigation = function (event) {
        if (!this.hasUnsavedChanges) {
            return;
        }
        event.preventDefault();
        event.returnValue = '';
    };
    TalentEmailView.prototype.beforeDestroy = function () {
        window.removeEventListener('beforeunload', this.preventNavigation);
    };
    var _a;
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], TalentEmailView.prototype, "talent", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", Array)
    ], TalentEmailView.prototype, "threads", void 0);
    __decorate([
        talentEmail.Mutation,
        __metadata("design:type", Function)
    ], TalentEmailView.prototype, "setSelectedThread", void 0);
    __decorate([
        Watch('threads', { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TalentEmailView.prototype, "checkThreads", null);
    TalentEmailView = __decorate([
        Component({
            components: {
                EmptyState: EmptyState,
                StatefulThreadBrowser: StatefulThreadBrowser,
            },
            beforeRouteLeave: function (to, from, next) {
                if (!this.hasUnsavedChanges) {
                    this.setSelectedThread(null);
                    return next();
                }
                if (window.confirm(this.$t('notifications.warning_changes_not_applied'))) {
                    this.setSelectedThread(null);
                    return next();
                }
            },
        })
    ], TalentEmailView);
    return TalentEmailView;
}(Vue));
export default TalentEmailView;
